import { Product } from "@/shared/utils/interfaces";
import PricePerTarget from "../PricePerTarget";
import VatPerTarget from "../VatPerTarget";
import ColorPerTarget from "../ColorPerTarget";

interface Props {
  defaultValue: Product;
  isShown: boolean;
}

const ProductModalAdvance = ({ defaultValue, isShown }: Props) => {
  return (
    <div className="min-h-[65rem]" style={{ display: isShown ? "block" : "none" }}>
      <PricePerTarget data={defaultValue} />
      <VatPerTarget data={defaultValue} />
      <ColorPerTarget data={defaultValue} />
      {/* <TargetValues product={defaultValue} /> */}
    </div>
  );
};

export default ProductModalAdvance;
